import { c as _c } from "react/compiler-runtime";
import { XCircleIcon } from '@systemeio/icons';
import type { ReactNode } from 'react';
import { ActionMenu, Button, SafeHtmlText, type ActionMenuItemProps } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface NotificationItemViewProps {
  /** Overrides the row chrome — a table cell already supplies its own padding and hover. */
  className?: string;
  isRead?: boolean;
  icon?: ReactNode;
  message: string;
  description?: ReactNode;
  showCancelButton?: boolean;
  isCancelling?: boolean;
  actions?: ActionMenuItemProps[];
  onClick?: () => void;
  onCancel?: () => void;
}
export const NotificationItemView = t0 => {
  const $ = _c(33);
  const {
    className,
    isRead,
    icon,
    message,
    description,
    showCancelButton,
    isCancelling,
    actions,
    onClick,
    onCancel
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const hasActions = Boolean(actions?.length);
  let t1;
  if ($[0] !== message) {
    t1 = <SafeHtmlText className="break-words" html={message} />;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <div className="text-text-disabled">{description}</div>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex min-w-0 flex-1 flex-col gap-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== icon || $[8] !== t3) {
    t4 = <div className="flex min-w-0 flex-1 items-start gap-2 text-start">{icon}{t3}</div>;
    $[7] = icon;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const content = t4;
  const t5 = onClick && "hover:bg-bg-tertiary";
  let t6;
  if ($[10] !== className || $[11] !== t5) {
    t6 = twMerge("transition-base flex w-full items-center gap-3 rounded-md p-2.5 transition-colors", t5, className);
    $[10] = className;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== content || $[14] !== onClick) {
    t7 = onClick ? <button className="focus-visible:focus-ring-primary min-w-0 flex-1 rounded-md outline-none" onClick={onClick} type="button">{content}</button> : content;
    $[13] = content;
    $[14] = onClick;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isCancelling || $[17] !== onCancel || $[18] !== showCancelButton || $[19] !== t) {
    t8 = showCancelButton && <Button aria-label={t("global.cancel")} className="my-auto rounded-full" isLoading={isCancelling} onClick={event => {
      event.stopPropagation();
      onCancel?.();
    }} size="icon-sm" variant="ghost-gray"><XCircleIcon /></Button>;
    $[16] = isCancelling;
    $[17] = onCancel;
    $[18] = showCancelButton;
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== isRead) {
    t9 = !isRead && <span aria-hidden={true} className="bg-bg-accent-active size-1.5 shrink-0 rounded-full" />;
    $[21] = isRead;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== actions || $[24] !== hasActions || $[25] !== t) {
    t10 = hasActions && actions && <ActionMenu ariaLabel={t("global.more_actions")} menuItems={actions.map(_temp)} />;
    $[23] = actions;
    $[24] = hasActions;
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t11 = <div className={t6}>{t7}{t8}{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
function _temp(action, index) {
  return {
    ...action,
    id: `notification-action-${index}`
  };
}